import { render, staticRenderFns } from "./ModalEditReceiveMethod.vue?vue&type=template&id=553c1e31&"
import script from "./ModalEditReceiveMethod.vue?vue&type=script&lang=js&"
export * from "./ModalEditReceiveMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports